import range from "../datos/range";

const obligatorio = [
    [3, [1177, 1179]], // (Cambio de Vehiculo)
    [11, [1180, 1181]], // (Canje de placas)
    [12, [1182]], // (Emplacamiento)
    [15, range(1125, 1148, 1)], // Añadido 1. (Alta de concesion)
    [18, [1228]], // (Transferencia/Cesión de Derechos)

    [21, range(1211, 1213).concat(1239)], // (Expedir Cédula Única)
    [23, [1214]], // (Reponer Cédula Única)
    [25, range(1166, 1169, 1)], // (Modificar Concesión/Permiso)
    [26, [1178]], // (Cambio de Motor de Vehículo)
    [27, range(1230, 1234)], // (Expedir Título de Concesión)
    
    /* [32, [1210]], */
    [36, range(1149, 1155, 1).concat(1158, 1159, 1160)], // Añadido 2. (Alta de Permiso)
    [39, [1161, 1190, 1191].concat(range(1193, 1198, 1).concat(1200))], // (Pago de Derechos)
    [1001, [1187, 1189, 1224, 1225]], // (Revista vehicular)
    [1025, range(1207, 1209, 1)], // (Certificación de copias expedidas por el Sistema del Transporte Convencional)
    /* [1030, range(1170, 1176, 1).concat(range(1183, 1186, 1)).concat(1222, 1223)], */
    [1030, [1165].concat(range(1170, 1176, 1)).concat(range(1183, 1186, 1)).concat(1222, 1223)], // (Dictamen técnico)

    [1031, range(1201, 1206, 1)], // (Pago de Derechos Privados, Auxiliar y Conexo)
    [1032, [1236]], // (Designación de Beneficiario)
]

export const tramitesObligatorios = obligatorio.map(item => item[0]);
export const conceptosObligatorios = [...(obligatorio.map(item => item[1]).flat())];

export default obligatorio;
